import { useEffect } from "react";

// SEO for blog pages. Updates the SINGLE existing <title>, <link canonical> and
// og:* tags in <head> imperatively (no duplicates), renders the page-unique
// meta description + optional JSON-LD via React 19 metadata hoisting, and
// restores the brand defaults on unmount so core-page SEO stays intact.
export const BlogSeo = ({ title, description, canonical, jsonLd }) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    const setMeta = (selector, attr, value) => {
      const el = document.querySelector(selector);
      if (!el || value == null) return null;
      const prev = el.getAttribute(attr);
      el.setAttribute(attr, value);
      return () => el.setAttribute(attr, prev ?? "");
    };

    const restores = [
      setMeta('link[rel="canonical"]', "href", canonical),
      setMeta('meta[property="og:url"]', "content", canonical),
      setMeta('meta[property="og:title"]', "content", title),
      setMeta('meta[property="og:description"]', "content", description),
      setMeta('meta[name="twitter:title"]', "content", title),
      setMeta('meta[name="twitter:description"]', "content", description),
    ].filter(Boolean);

    return () => {
      document.title = prevTitle;
      restores.forEach((fn) => fn());
    };
  }, [title, description, canonical]);

  return (
    <>
      <meta name="description" content={description} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </>
  );
};
